const noLeadingZeros = value => {
	const firstNonZeroIndex = Array.prototype.findIndex.call(
		value,
		char => char !== '0',
	);
	return firstNonZeroIndex === -1 ? value : value.substr(firstNonZeroIndex);
};

export default noLeadingZeros;
